function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

import { textColor } from "./color";

var getSvgFont = function getSvgFont(a) {
  var b = a.fontFamily,
      c = a.fontSize,
      d = a.letterSpacing;
  return {
    fill: textColor,
    stroke: "none",
    fontFamily: b,
    fontSize: c,
    letterSpacing: d
  };
},
    fontFamily = "BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif";

export default {
  fontFamily: fontFamily,
  // weights
  light: {
    fontWeight: 200
  },
  bold: {
    fontWeight: 700
  },
  // alignment
  start: {
    textAnchor: "start"
  },
  middle: {
    textAnchor: "middle"
  },
  end: {
    textAnchor: "end"
  },
  // size
  tiny: _extends({}, getSvgFont({
    fontFamily: fontFamily,
    fontSize: 10,
    letterSpacing: .4
  })),
  small: _extends({}, getSvgFont({
    fontFamily: fontFamily,
    fontSize: 12,
    letterSpacing: .4
  })),
  regular: _extends({}, getSvgFont({
    fontFamily: fontFamily,
    fontSize: 14,
    letterSpacing: .2
  })),
  large: _extends({}, getSvgFont({
    fontFamily: fontFamily,
    fontSize: 18,
    spacing: 0
  }))
};